<template>
  <div class="errwrapper">
    <TableToolTemp :toolListProps="{ toolTitle: '保全失败原因列表' }">
      <template #tips>
        <span>保全号：{{ errinfo.endorsementNo }}</span>
      </template>
    </TableToolTemp>
    <Table :data="tableData" :options="listDataOptions" align="center">
      <template v-slot:index>
        <el-table-column type="index" label="序号" width="100"></el-table-column>
      </template>
    </Table>
    <Pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :pageData="initParam"
      :total="total"
    ></Pagination>
  </div>
</template>
<script>
import TableToolTemp from '@/components/layouts/TableToolTemp';
import Table from '@/components/layouts/table';
import { myMixin } from '@/mixins';
import Pagination from '@/components/layouts/Pagination';
import { preservationunusualList } from '@/api/securityManage';
export default {
  mixins: [myMixin],
    watch: {
    'errinfo.preservationId': {
      deep: true,
      immediate: true,
      handler(newval, oldval) {
        if (newval ) {
           this.initParam.pageSize= 10;
          this.queryData(false)

        }
      },
    },
  },
  props: {
    errinfo: {
      type: Object,
      default: () => {},
    },
  },
  components: {
    TableToolTemp,
    Table,
    Pagination,
  },
  data() {
    return {
      tableData: [],
      listDataOptions: [
        {
          prop: 'errorMessage',
          label: '保全失败原因',
        },
      ],
      initParam: {
        pageNum: 1,
        pageSize: 10,
        param: {
          preservationId: '',
          preservationType: '01',
          status: '1',
        },
      },
      total: 0,
      
    };
  },
  methods: {
    // init() {
    //   this.queryData();
    // },
     queryData(bool = true) {
      // 默认将当前页数归1
      if (bool) this.initParam.pageNum = 1;
        //  pageNum: 1, 当前页
        // pageSize: 10,//每页数据几条
        let {pageSize,pageNum}=this.initParam
        let allData=JSON.parse(this.errinfo.failReason) 
          this.tableData=allData.slice(pageSize*(pageNum-1),pageSize*pageNum)
          this.total=allData.length
    },
    handleSizeChange(val){
      this.initParam.pageNum = 1;
      this.initParam.pageSize = val;
      this.queryData();
    },
    handleCurrentChange(val){
      this.initParam.pageNum = val;
      this.queryData(false);
    }
  },
};
</script>
<style lang="less" scoped>
.errwrapper{
  padding-bottom:20px;
}
</style>